// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import CheckSquareTwoToneSvg from "@fishx/icons-svg/es/asn/CheckSquareTwoTone";
import FishxIcon from '../components/FishxIcon';

var CheckSquareTwoTone = function CheckSquareTwoTone(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: CheckSquareTwoToneSvg
  }));
};

CheckSquareTwoTone.displayName = 'CheckSquareTwoTone';
export default React.forwardRef(CheckSquareTwoTone);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/CheckSquareTwoTone.js
// module id = 2206
// module chunks = 0